import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button'
import { Collapse } from 'reactstrap';
import { EARLIEST_AVAILABLE_YEAR, HOMEPAGE_URL } from './../../constants';
import ScoreMeter from './../ScoreMeter/ScoreMeter';
import {
    EmailShareButton,
    EmailIcon,
    FacebookShareButton,
    FacebookIcon,
    LinkedinShareButton,
    LinkedinIcon,
} from "react-share";
import campaignWeathervaneLogo from './../../assets/img/campaign-weathervane-logo.webp'
import './ScoreSharing.scss'
import Box from "@mui/material/Box";
import Confetti from 'react-confetti'
import Grid from "@mui/material/Grid";



function ScoreSharing(props) {
    const [shareCollapse, setShareCollapse] = useState(false)
    const timeline = props.gameState.timeline
    const score = props.gameState.score
    const localStorage = window.localStorage
    const header = ["I scored", Math.round(score) + "%", "on the year of", timeline + "'s", "polling data", "Roper's Campaign Weathervane! "].join(" ")
    const body = "Roper Game challenges the way you see and evaluate polling data throughout the US history. Join the challenge to see if you can beat my score!"

    var nextYear = timeline - 10
    var reachedEarliestYear = false
    if (timeline === EARLIEST_AVAILABLE_YEAR){
        nextYear = timeline 
        reachedEarliestYear = true
    }

    function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
    }



    const buttonStyle = {
        margin: 1,
        width: "20%",
    };



    var finalMessage = ""
    var imgSrc = null
    var textColor = ""
    if (score < 51) {
        finalMessage = "Candidate Weathervane lost the race, but still had a great showing for a third party candidate. History remains the same."
        imgSrc = campaignWeathervaneLogo
        textColor = "#B2292D"
    } else if (score <= 60 ) {
        finalMessage = "Candidate Weathervane won the race by a slim margin and changed history!"
        imgSrc = campaignWeathervaneLogo
        textColor = "#6EB43F"
    } else if (score <= 80 ) {
        finalMessage = "Candidate Weathervane won the race decisively and changed history!"
        imgSrc = campaignWeathervaneLogo
        textColor = "#6EB43F"
    } else {
        finalMessage = "Candidate Weathervane successfully changed history by a landslide with " + Math.round(score) + "% of favorability!"
        imgSrc = campaignWeathervaneLogo
        textColor = "#6EB43F"
    }

    function handleTryAgain(year) {
        localStorage.clear()
        props.navigate(1, {timeline : year})
    }
    const { height, width } = getWindowDimensions();

    // Run confetti loop for 20 seconds
    const [confettiRecycle, setConfettiRecycle] = useState(true)
    useEffect(() => {
        const timer = setTimeout(() => {
            setConfettiRecycle(false)
        }, 20000);
        return () => clearTimeout(timer);
    }, []);


    // LINKEDIN SHARING CAN ONLY SHARE THE LINK WITHOUT IF NOT A LINKEDIN BUSINESS PARTNER 
    return (
        <div className="container score-sharing-container">
            {score >= 51 && <Confetti width={width} height={height} numberOfPieces={300} recycle={confettiRecycle}/>}
            <div className="img-container">
                <img className="campaign-weathervane-logo" src={imgSrc} alt={"Campaign Weathervane logo"}/>
                <div className='year-text'>{timeline}</div>
            </div>
            <h1 className='final-message' style={{color: textColor, textAlign: "center"}}>{finalMessage}</h1>
            <Box display='flex' flexDirection='column' position='relative'>
                <ScoreMeter percentage={Math.round(score)}/>
                {score < 51? (
                    <Box sx={{textAlign:'center', fontSize:'48pt', color:"#B2292D"}}>
                        {Math.round(props.gameState.score)}%
                    </Box>
                ):( <Box sx={{textAlign:'center', fontSize:'48pt', color:"#6EB43F"}}>
                    {Math.round(props.gameState.score)}%
                </Box>)}
            </Box>
            <Box display='flex' flexDirection='column' sx={{justifyContent:'center', alignItems:'center', spacing: 2}}>
                <Button sx={buttonStyle} className="button-primary" onClick={() => setShareCollapse(!shareCollapse)}>Share your result!</Button>
                <Collapse isOpen={shareCollapse}>
                    <FacebookShareButton url={'https://ropercenter.cornell.edu/campaign-weathervane'} quote={header + body} className="social-media-button">
                        <FacebookIcon size={40} round />
                    </FacebookShareButton>
                    <LinkedinShareButton url={'https://ropercenter.cornell.edu/campaign-weathervane'} className="social-media-button">
                        <LinkedinIcon size={40} round />
                    </LinkedinShareButton>
                    <EmailShareButton url={'https://ropercenter.cornell.edu/campaign-weathervane'} subject={header} body={body} className="social-media-button">
                        <EmailIcon size={40} round />
                    </EmailShareButton>
                </Collapse>
                <Button sx={buttonStyle} className="button-primary mt-2" onClick={() => props.navigate(0)}>Go to Homepage</Button>
            </Box>


        </div>
    );
}

export default ScoreSharing;
